import type { TFunction } from "i18next";
import { isNumberStringValid } from "./isNumberStringValid";
import { isRequiredStringValid } from "./isRequiredStringValid";

/** Validates the counter start value of a number range (e.g. CreditNumberRange or InvoiceNumberRange). */
export function validateNumberRangeCounterStartValue(
  value: string | null | undefined,
  t: TFunction
) {
  if (!isRequiredStringValid(value)) {
    return t("errors.Required");
  }

  if (!isNumberStringValid(value)) {
    return t("errors.NumberRanges.counterStartValueError");
  }

  return "";
}
